import React from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
import SharedGradeUk from "./SharedGradeUk";
const TITLE = "تحويل المعدل الجامعي الى النظام البريطاني - بكالوريوس و ماجستير";
const DESCRIPTION =
  "قم بتحويل معدلك الجامعي إلى النظام البريطاني للدرجات بسهولة ودقة. اعرف كيفية تحويل معدل البكالوريوس والماجستير من النظام الجامعي إلى النظام البريطاني باستخدام هذه الأداة المفيدة.";
const KEYWORDS =
  "تحويل المعدل الجامعي, تحويل إلى النظام البريطاني, تحويل معدل البكالوريوس, تحويل معدل الماجستير, المعدل الجامعي, النظام البريطاني";
const OG_URL = "https://do-calculate.com/calculator/ar/gradetouk";
function GradeToUk() {
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  قم بتحويل معدلك الجامعي (مئوي او تراكمي) إلى النظام البريطاني
                  للدرجات بسهولة ودقة. اعرف كيفية تحويل معدل البكالوريوس
                  والماجستير من النظام الجامعي إلى النظام البريطاني باستخدام هذه
                  الأداة المفيدة.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col">
                <SharedGradeUk />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      {" "}
                      نظام تصنيف الدراسات الجامعية في المملكة المتحدة{" "}
                    </h2>
                  </u>
                  <p>
                    في المملكة المتحدة، تقدم الجامعات نوعين من درجات
                    البكالوريوس: درجة الشرف ودرجة العادي.
                    <br />
                    درجات الشرف هي الأكثر شيوعاً. يمكنك إكمال درجة الشرف بعلامات
                    أو درجات مختلفة. استنادًا إلى علاماتك، يمكنك الحصول على 4
                    أنواع من شهادة الشرف عند تخرجك:
                    <br/>                    <b>درجة الشرف الأولى (First-Class Honours أو 1st):</b>
                    تعادل الدرجة A. يجب أن تكمل دراستك بعلامة عامة تبلغ 70٪ أو
                    أعلى. إنها إنجاز أكاديمي رائع وتمثل ميزة عند التقديم للحصول
                    على درجة الماجستير أو وظيفة.
                    <br />
                    <b>
                      درجة الشرف الثانية العليا (Upper Second-Class Honours أو
                      2:1):
                    </b>
                    تعادل الدرجة B. تحتاج إلى درجة عامة تتراوح بين 60-69٪ للحصول
                    عليها. هذا النوع من الدرجة هو متطلب شائع عند التقديم لبرامج
                    الماجستير.
                    <br />
                    <b>
                      درجة الشرف الثانية الدنيا (Lower Second-Class Honours أو
                      2:2):
                    </b>
                    تعادل الدرجة C. للحصول على هذه الدرجة، تحتاج إلى علامة
                    تتراوح بين 50-59٪. إنها ليست بمكانة مشهورة مثل درجة الشرف
                    الأولى أو 2:1 ولكنها مقبولة من قبل بعض برامج الماجستير.
                    <br />
                    <b>درجة الشرف الثالثة (Third-Class Honours أو 3rd).</b>
                    تعادل الدرجة D. يُمنح هذا النوع من الدرجة للطلاب الذين ينهون
                    دراستهم بعلامة عامة تتراوح بين 40-49٪. بينما هو لا يزال
                    ناجحًا، إلا أنه سيكون من الصعب جدًا التنافس مع الطلاب
                    الآخرين عند التقديم لبرنامج الماجستير.
                    <br/>                  </p>
                  <div className="p-3 mb-2 bg-warning text-dark">
                    إذا كانت علامتك العامة أقل من 40٪، فإنك تكون راسبًا، وتعادل
                    ذلك استلام الدرجة F. درجات العادي أقل شيوعًا ولكن تُقدم
                    كدرجات فردية من قبل بعض الجامعات. يمكن أيضًا منحها للطلاب
                    الذين يكملون درجة الشرف، ولكن دون تحقيق الحد الأدنى من
                    الشروط للحصول على إحدى شهادات الشرف.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      {" "}
                      نظام تصنيف الدراسات العليا في المملكة المتحدة
                    </h2>
                  </u>
                  نظام تصنيف الدراسات العليا لدرجات الماجستير مشابه لنظام الشرف،
                  ولكنه يختلف في بعض النقاط. الحد الأدنى للنجاح هو 50٪ بدلاً من
                  40٪. الشهادات الكاملة تبدو على النحو التالي:
                  <ul>
                    <li>تمييز: 70-100٪</li>
                    <li>جيد جدًا: 60-69٪</li>
                    <li>ناجح: 50-59٪</li>
                    <li>راسب: أقل من 50٪</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      {" "}
                      تحويل الدرجات البريطانية إلى المعدل التراكمي (GPA)
                    </h2>
                  </u>
                  تستخدم الجامعات والكليات الأمريكية عادة معدل التراكمي للدرجات
                  (GPA) لتقييم الأداء العام للطلاب. يتم حساب المعدل التراكمي
                  للدرجات باستخدام درجاتك وعدد الساعات المعتمدة لكل دورة دراسية
                  تقوم بها. تبدو التحويل التقريبي للدرجات البريطانية إلى المعدل
                  التراكمي للدرجات (GPA) على النحو التالي:
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>المعدل على النظام البريطاني</th>
                        <th>المعدل التراكمي (GPA) </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>First-Class Honours (1st)</td>
                        <td>4.0</td>
                      </tr>
                      <tr>
                        <td>Upper Second-Class Honours (2:1)</td>
                        <td>3.3 - 3.9</td>
                      </tr>
                      <tr>
                        <td>Lower Second-Class Honours (2:2)</td>
                        <td>2.7 - 3.2</td>
                      </tr>
                      <tr>
                        <td>Third-Class Honours (3rd)</td>
                        <td>2.0 - 2.6</td>
                      </tr>
                      <tr>
                        <td>Pass</td>
                        <td>1.0 - 1.9</td>
                      </tr>
                      <tr>
                        <td>Fail</td>
                        <td>0.0</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="p-3 mb-2 bg-warning text-dark">
                    أقل من 40% = 1.0-1.9 – هذا ليس بالضرورة فشلًا؛ في بعض
                    الجامعات، قد يكون مكافئًا للحصول على درجة عادية في المملكة
                    المتحدة.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GradeToUk;
